import {
  requestMortuaryList,
  requestMortuaryRegist,
  requestMortuaryUpdate,
  requestMortuaryRemove,
  requestEnterList,
  requestEnterRoomRegist,
  requestEnterRoomUpdate,
  requestEnterRoomRemove
} from "@/apis/mortuary_api";

import router from "@/router";

const state = {
  mortuaryList: [],
  enterRoomList: []
};

const getters = {
  getMortuaryList(state) {
    return state.mortuaryList;
  },
  getEnterRoomList(state) {
    return state.enterRoomList;
  }
};

const mutations = {
  MORTUARY_LIST(state, data) {
    state.mortuaryList = data.resultMortuary;
  },

  ENTER_ROOM_LIST(state, data) {
    state.enterRoomList = data.resultEnterRoom;
  },

  INIT_MORTUARY(state) {
    state.mortuaryList = [];
    state.enterRoomList = [];
  }
};

const actions = {
  async REQUEST_ENTER_LIST({ commit }) {
    try {
      commit("START_LOADING");
      const response = await requestEnterList();
      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }
      commit("ENTER_ROOM_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },
  // new
  async REQUEST_MORTUARY_LIST({ commit }) {
    try {
      commit("START_LOADING");
      const response = await requestMortuaryList();
      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }
      commit("MORTUARY_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },

  // new
  async REQUEST_MORTUARY_REGIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestMortuaryRegist(parameter);

      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }

      commit("MORTUARY_LIST", data);
      window.location.reload();
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },
  async REQUEST_MORTUARY_UPDATE({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestMortuaryUpdate(parameter);

      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }

      window.location.reload();
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },
  // new
  async REQUEST_MORTUARY_REMOVE({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestMortuaryRemove(parameter);

      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }

      window.location.reload();
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },
  //new
  async ENTER_ROOM_REGIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestEnterRoomRegist(parameter);
      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }

      commit("ENTER_ROOM_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },
  async REQUEST_ENTER_UPDATE({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestEnterRoomUpdate(parameter);

      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }

      window.location.reload();
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  },
  // new
  async REQUEST_ENTER_ROOM_REMOVE({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const response = await requestEnterRoomRemove(parameter);

      const { data } = response;
      if (data?.result !== "success") {
        return alert(data.message);
      }

      window.location.reload();
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
